import React from 'react';
import { Breadcrumbs, Hidden, Link, Typography } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { breadcrumbNameMap } from 'app/utils/mapper';
import clsx from 'clsx';

const Breadcrumb = props => {
  const {
    history,
    location: { pathname },
    title,
    sidebar = false
  } = props;
  const pathnames = pathname.split('/').filter(x => x);

  const goToHome = () => history.push('/');

  return (
    <>
      <div
        className={clsx(
          'w-full flex flex-col justify-center items-center p-8 space-y-4 md:p-24 md:flex-row md:justify-between md:space-y-0',
          sidebar && 'lg:justify-end'
        )}>
        <Hidden lgUp={sidebar}>
          <Typography variant="h5" component="h1" className="font-semibold tracking-wider">
            {title}
          </Typography>
        </Hidden>

        <Breadcrumbs maxItems={4} aria-label="breadcrumb">
          {pathnames.length > 0 ? (
            <Link
              className="font-normal mt-8 hover:text-blue-600 cursor-pointer"
              onClick={goToHome}>
              Anasayfa
            </Link>
          ) : (
            <Typography> Anasayfa </Typography>
          )}
          {pathnames.map((name, index) => {
            if (breadcrumbNameMap[name]) {
              const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
              const isLast = index === pathnames.length - 1;
              return isLast ? (
                <Typography key={name} aria-current="page">
                  {breadcrumbNameMap[name]}
                </Typography>
              ) : (
                <Link
                  className="font-normal mt-8 hover:text-blue-600 cursor-pointer"
                  key={name}
                  onClick={() => history.push(routeTo, { from: pathname })}>
                  {breadcrumbNameMap[name]}
                </Link>
              );
            }
            return null;
          })}
        </Breadcrumbs>
      </div>
    </>
  );
};

export default withRouter(Breadcrumb);
